import { render } from "./CreditsTable.vue?vue&type=template&id=9961571a&scoped=true"
import script from "./CreditsTable.vue?vue&type=script&lang=js"
export * from "./CreditsTable.vue?vue&type=script&lang=js"

import "./CreditsTable.vue?vue&type=style&index=0&id=9961571a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9961571a"]])

export default __exports__